import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CheckboxesTags({ options, getOptionLabel,value, onChangeValue, label, placeholder }) {
  console.log("options",options,"value",value)
  // const [value, setValue] = React.useState();
  const [inputValue, setInputValue] = React.useState('');

  const SELECT_ALL_OPTION = { name: 'Select All', value: '__select_all__' };

  const allSelected =
    value.length > 0 && value.length === options.length;

  const displayOptions = [SELECT_ALL_OPTION, ...options];

  const handleChange = (event, newValue) => {
    console.log("newValue",newValue)
    const lastSelected = newValue[newValue.length - 1];

    if (!lastSelected) {
      onChangeValue([]);
      return;
    }

    if (lastSelected.value === SELECT_ALL_OPTION.value) {
      if (allSelected) {
        onChangeValue([]);
      } else {
        onChangeValue([...options]);
      }
    } else {
      // Filter out SELECT_ALL_OPTION if present
      const filtered = newValue.filter(
        (item) => item.value !== SELECT_ALL_OPTION.value
      );
      onChangeValue(filtered);
    }
  };

 const isOptionSelected = (option) => {
    if (option.value === SELECT_ALL_OPTION.value) {
      return allSelected;
    }
    return value.some(
      (selected) =>
        selected.value === option.value && selected.name === option.name
    );
  };

  // const [selectAllChecked, setSelectAllChecked] = React.useState(false);

  // React.useEffect(() => {
  //   if(value && options){
  //     setSelectAllChecked(value.length === options.length);
  //   }
  // }, [value, options])

  // const handleSelectAllChange = () => {
  //   if (selectAllChecked) {
  //     onChangeValue([]); // Deselect all
  //   } else {
  //     onChangeValue(options); // Select all
  //   }
  //   setSelectAllChecked(!selectAllChecked);
  // }

  return (
    <Autocomplete
      multiple
      limitTags={3}
      id="checkboxes-tags-demo"
      // options={options}
      options={displayOptions}
      disableCloseOnSelect
      value={value}
      onChange={handleChange}
        // onChange={(event, newValue) => {
        //   console.log("checkboxescomponchange",event,newValue)
        //   onChangeValue(newValue);
        // }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          console.log("checkboxescomponInputChange",event,newInputValue)
          setInputValue(newInputValue);
        }}
      getOptionLabel={(option) => option.name || option.value}
      // getOptionLabel={getOptionLabel}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        const isChecked = value.some(item => item.value === option.value || item.name === option.name);
        const checked = isOptionSelected(option);
        return (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={checked}
              // checked={selected}
              // checked={isChecked}
            />
            {option.name || option.value}
            {/* {getOptionLabel} */}
          </li>
        );
      }}
      style={{ width: 500 }}
      renderInput={(params) => (
        <TextField {...params} label={
          <span
            style={{ color: "black", fontWeight: "bold" }}
          >{label}</span>
        }
          placeholder={placeholder} />
      )}
      // renderTags={(value, getTagProps)=> [
      //   <Checkbox
      //     key="selectAll"
      //     icon={icon}
      //     checkedIcon={checkedIcon}
      //     style={{ marginRight: 8 }}
      //     checked={selectAllChecked}
      //     onChange={handleSelectAllChange}
      //   />,
      //   ...value.map((option, index) => (
      //     <span {...getTagProps({ index })} key={index}>
      //       {option.name || option.value}
      //     </span>
      //   )),
      // ]}
    />
  );
}